// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","footerContent":"Footer_footerContent__E5RXg","footerSocial":"Footer_footerSocial__Lz9Ys","socialIcon":"Footer_socialIcon__vNbla"};